import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { BlockWrapper, GoBackButtonWithTitle } from 'components';
import { useWindowSize } from 'hooks';
import { Links } from 'settings';

import { CardsW, CardW, PageW, TitleText, TitleW } from './styled';

export function SettingsPage(): ReactElement {
  const { isMobile } = useWindowSize();
  const { t } = useTranslation();

  const navigate = useNavigate();

  return (
    <PageW>
      <GoBackButtonWithTitle
        title={t('settings.title')}
        containerSx={{
          marginBottom: isMobile ? '16px' : '24px',
          '.title': {
            fontSize: '24px',
          },
        }}
        Actions={<></>}
      />
      <BlockWrapper
        wrapperSx={{
          marginBottom: isMobile ? '16px' : '24px',
          width: '100%',
          padding: isMobile ? '16px 8px' : '16px',
          borderRadius: '8px',
          border: '1px solid #ddd',
        }}
        title=""
      >
        <CardsW>
          <CardW onClick={() => navigate(Links.settings.userManagement)}>
            <TitleW>
              <TitleText>{t('settings.userProfile.title')}</TitleText>
            </TitleW>
          </CardW>
        </CardsW>
      </BlockWrapper>
    </PageW>
  );
}
